import React, { Fragment, useEffect, useState } from 'react';
import { Settings } from 'react-feather';
import { Link } from 'react-router-dom';
import { H6, Image, LI, UL, P } from '../../AbstractElements';
import man from '../../assets/images/dashboard/1.png';
import axios from 'axios';
import { BaseURL, uniqueToken } from '../../api/DataApis';
// import SBILogo from  "../../assets/images/sbi_logo";

const Profile = () => {
    const authenticated = JSON.parse(localStorage.getItem('authenticated'));
    const auth0_profile = JSON.parse(localStorage.getItem('auth0_profile'));
    const [profile, setProfile] = useState('');
    const [name, setName] = useState('');

    useEffect(() => {
        setProfile(localStorage.getItem('profileURL') || man);
        setName(localStorage.getItem('Name'));
    }, [setProfile, setName]);

    const [adminData, setAdminData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [singleAdmin, setSingleAdmin] = useState(null);
  
    const userData = JSON.parse(localStorage.getItem("userData"));
  
  

    return (
        <Fragment>
            <div className="sidebar-user text-center">
                {/* <a className="setting-primary" href="#javascript">
                    <Settings />
                </a> */}
                <Link to={`/profile`} className='d-flex align-items-center'>
                    <Image attrImage={{ 
                        className: 'img-90 rounded-circle', 
                        src: authenticated ? `${BaseURL}/uploads/images/${singleAdmin?.photo}` : profile, 
                        alt: '' 
                    }} />
                    {/* <div className="badge-bottom">
                        <div className="badge badge-primary">New
                        </div>
                    </div> */}
                    

                    <h6 className='ps-2'>
                    {userData?.name 
                    ? userData.name
                        .split(" ") // Split into words
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
                        .join(" ") // Join words back
                    : ""}

                    </h6>


                </Link>
                {/* <P attrPara={{ className: 'mb-0 font-roboto' }} >Evtor</P>
                <UL attrUL={{ className: 'flex-row simple-list' }}>
                   </UL> */}
            </div>
        </Fragment >
    );
};

export default Profile;